import { PageType, Section } from '@domain-group/fe-co-allhomes-ads';
var getAdTargeting = () => {
  var _category$subCategory, _category$primaryCate, _category$subCategory2, _titan$adKeyValues, _titan$adKeyValues2, _titan$adKeyValues3;
  if (typeof window === 'undefined') {
    // Only works client side
    return null;
  }
  var digitalData = window.digitalData || {};
  var _digitalData$page = digitalData.page,
    page = _digitalData$page === void 0 ? {} : _digitalData$page,
    _digitalData$titan = digitalData.titan,
    titan = _digitalData$titan === void 0 ? {} : _digitalData$titan;
  var _page$category = page.category,
    category = _page$category === void 0 ? {} : _page$category;
  var getSection = () => {
    if (category.primaryCategory === 'Rent') {
      return Section.Rent;
    }
    if (category.primaryCategory === 'Developments') {
      return Section.NewHomes;
    }
    return Section.Buy;
  };
  var config = {
    pageType: PageType.SearchResults,
    section: getSection()
  };
  var data = {
    cat: (_category$subCategory = category.subCategory2) === null || _category$subCategory === void 0 ? void 0 : _category$subCategory.toLowerCase(),
    cat1: (_category$primaryCate = category.primaryCategory) === null || _category$primaryCate === void 0 ? void 0 : _category$primaryCate.toLowerCase(),
    cat2: 'Browseregion',
    cat3: (_category$subCategory2 = category.subCategory1) !== null && _category$subCategory2 !== void 0 && _category$subCategory2.match(/Area/i) ? 'Browsearea' : null,
    ctype: 'index',
    locstate: (_titan$adKeyValues = titan.adKeyValues) === null || _titan$adKeyValues === void 0 ? void 0 : _titan$adKeyValues.locstate,
    // TODO - Don't use Titan, pass this in specifically
    locregion: ((_titan$adKeyValues2 = titan.adKeyValues) === null || _titan$adKeyValues2 === void 0 ? void 0 : _titan$adKeyValues2.locstate) === 'act' ? 'canberra queanbeyan' : (_titan$adKeyValues3 = titan.adKeyValues) === null || _titan$adKeyValues3 === void 0 ? void 0 : _titan$adKeyValues3.locarea // TODO - Don't use Titan, pass this in specifically
  };
  return {
    config,
    data
  };
};
export default getAdTargeting;